var service = {};

if (process.env.NODE_ENV === 'production') {
    service.API_URL = 'https://elite-api.thriftyspends.com';
} else {
    service.API_URL = 'https://elite-api.thriftyspends.com';

    // service.API_URL = 'http://192.168.29.117:5002';
}

export default service;
